import gql from 'graphql-tag';

export const QuerySkillsQuery = gql`
  query QuerySkillsQuery($input: QuerySkillsVariables!) {
    QuerySkills(input: $input)
      @rest(type: "QuerySkillsResponse", path: "grpc/skills/v2/SkillsAPI/QuerySkills", method: "POST") {
      skills {
        skillId
        skillName
        parentSkillIds
        childSkillIds
        skillDescription
      }
    }
  }
`;

export const MultiGetSkillsQuery = gql`
  query MultiGetSkillsQuery($input: MultiGetSkillsVariables!) {
    MultiGetSkills(input: $input)
      @rest(type: "MultiGetSkillsResponse", path: "grpc/skills/v2/SkillsAPI/MultiGetSkills", method: "POST") {
      skills {
        skillId
        skillName
        childSkillIds
        occupationIds
      }
    }
  }
`;

export const QuerySkillsParentIdQuery = gql`
  query QuerySkillsQuery($input: QuerySkillsVariables!) {
    QuerySkills(input: $input)
      @rest(type: "QuerySkillsResponse", path: "grpc/skills/v2/SkillsAPI/QuerySkills", method: "POST") {
      skills {
        skillId
        skillName
        childSkillIds
        occupationIds
      }
    }
  }
`;
